import Image from 'next/image';
import { useState } from 'react';
import { BsSearch, BsLink } from 'react-icons/bs';
import { useRouter } from 'next/router';
import { isEqual } from 'lodash';
import Link from 'next/link';

import { ProductsModel } from '../../../interface/products';
import { useMediaQuery, MediaQuery } from '../../../hooks/useMediaQuery';
import { SUBZERO_SLUG } from '../../../constants/brands';
import CustomButton from '../../atoms/custom-button/custom-button';
import AnimatedDiv from '../../atoms/animated-div/animated-div';
import { CardModal } from '../../atoms/card-modal/card-modal';
import * as S from './styles';

/* eslint-disable-next-line */
type ProductCardProps = {
  product: ProductsModel;
};

export function ProductCard(props: ProductCardProps) {
  const { product } = props;
  const { attributes } = product;
  const router = useRouter();
  const brand = router.query.brand;
  const isMobile = useMediaQuery(MediaQuery.SM);

  const textColor = isEqual(brand, SUBZERO_SLUG)
    ? 'text-primaryBlue'
    : 'text-primaryRed';
  const [isOpen, setIsOpen] = useState(false);

  function handleOpenModal() {
    setIsOpen(true);
  }

  return (
    <S.Container>
      <AnimatedDiv
        className="flex flex-col border border-breadcrumbGray grid-flow-col h-112 p-4 relative"
        key={product.id}
      >
        <div className="image-container w-full h-64 md:h-40 block relative group">
          <Image
            alt="product image"
            blurDataURL="/icons/blur-placeholder.png"
            layout="fill"
            objectFit="contain"
            placeholder="blur"
            src={attributes.HeadOnImages?.data?.[0]?.attributes?.url}
          />
          <CardModal
            isOpen={isOpen}
            singleImageHeight={isMobile ? 100 : 55}
            src={attributes.HeadOnImages?.data?.[0]?.attributes?.url}
            setIsOpen={setIsOpen}
          />

          <div className="flex absolute z-50 top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 space-x-2 invisible group-hover:visible">
            <div
              className="text-white border-2 border-white rounded-full cursor-pointer hover:text-primaryBlue hover:bg-white"
              onClick={handleOpenModal}
            >
              <BsSearch className="text-header3 p-3 lg:text-header4 lg:p-2" />
            </div>
            <Link
              passHref
              href={`/${router.query.brand}/products/${product.attributes.websiteSlug}`}
            >
              <a className="text-white border-2 border-white rounded-full cursor-pointer hover:text-primaryBlue hover:bg-white">
                <BsLink className="text-header3 p-3 lg:text-header4 lg:p-2" />
              </a>
            </Link>
          </div>
        </div>

        <div className="flex flex-col mt-4 md:mt-10">
          <p
            className={`${textColor} text-left font-MuseoSans300 text-subtitle uppercase`}
          >
            {attributes.ModelName}
          </p>
          <p className="text-primaryGray text-subtitle">
            {attributes.ModelNumber}
          </p>
          <CustomButton
            hasLink
            buttonStyle="bg-widgetGray text-black hover:text-white hover:bg-primaryGray mt-4 w-34 absolute bottom-3 md:bottom-5 left-3 md:left-5"
            buttonText="VIEW PRODUCT >"
            ctaLink={`/${router.query.brand}/products/${product.attributes.websiteSlug}`}
            textStyle="border-primaryGray group-hover:border-white"
          />
        </div>
      </AnimatedDiv>
    </S.Container>
  );
}

export default ProductCard;
